export const CONTROL_TABLE_ALLOWED_USERS: string[] = ["teo"];

export function isControlTableUserAllowed(
  username: string | undefined,
): boolean {
  if (!username) return false;
  return CONTROL_TABLE_ALLOWED_USERS.map((u) => u.toLowerCase()).includes(
    username.trim().toLowerCase(),
  );
}

export interface ControlTableSecurity {
  SecIndex: number;
  SecNumber: string;
  SecISIN: string;
  SecStockExchange: number;
  SecSymbol: string;
  SecName: string;
  SecCurrSymbol: string;
  FxRate: number;
  StockExchangeCode: string;
  StockExchangeName: string;
  EODHDStockExchangeCode: string;
  SecType: number;
  SecCurr: number;
  SecFactor: number;
  SecContractSize: number;
}

export interface ControlTableRow {
  security: ControlTableSecurity;

  isDomestic: boolean;

  price: number | null;
  bestBid: number | null;
  bestBidQty: number | null;
  bestAsk: number | null;
  bestAskQty: number | null;
  open: number | null;
  high: number | null;
  low: number | null;
  volume: number | null;
  tradingPhase: string | null;
  priceRange: string | null;

  loading: boolean;
}

export interface ControlTable {
  id: string;
  name: string;
  createdAt: number;
  rows: ControlTableRow[];
}

export function createEmptyRow(
  security: ControlTableSecurity,
): ControlTableRow {
  return {
    security,
    isDomestic:
      security.SecStockExchange === 12 || security.SecStockExchange === 15,
    price: null,
    bestBid: null,
    bestBidQty: null,
    bestAsk: null,
    bestAskQty: null,
    open: null,
    high: null,
    low: null,
    volume: null,
    tradingPhase: null,
    priceRange: null,
    loading: true,
  };
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-control-table/control-table.models.ts